import { useTranslation } from 'react-i18next'

import { formatDate } from '@/helpers'
import { Button, Text } from '@mercai/clever'

import { ProfileHeaderProps } from './header.type'
import styles from './header.module.css'

export const Header = ({
  profile,
  setIsOpenGeneralInfosForm,
}: ProfileHeaderProps) => {
  const { t } = useTranslation('screenProfileShow')
  return (
    <div className={styles.header}>
      <div className={styles['header-row']}>
        <div>
          <Text variant="title-large">{profile?.companyName || ''}</Text>
          <div className={styles['info-box']}>
            <Text variant="text-small">
              {`${t('generalViewLastUpdate')}: ${formatDate(profile?.updatedAt || '')}`}
            </Text>
          </div>
        </div>
        <Button onClick={() => setIsOpenGeneralInfosForm(true)}>
          {t('headerEditLeadButton')}
        </Button>
      </div>

      <Text>
        {profile?.users
          ? profile?.users?.map((user) => user.name)?.join(', ')
          : ' - '}
      </Text>
    </div>
  )
}
